import React from "react";
import { useRefCallback } from "../../custom-hooks/useRefCallback";
import TextArea from "./TextArea";
import { withDefaults } from "../../utils/withDefaults";
import type { TextAreaProps } from "./TextArea";

/** Everything TextArea takes, minus the props this component controls itself. */
export type AutoSizeTextAreaProps = Omit<
  TextAreaProps,
  "reference" | "changeFn" | "delayedChangeFn" | "rows" | "hasBottomPadding"
>;

export default function AutoSizeTextArea(incomingProps: AutoSizeTextAreaProps) {
  const props = withDefaults(incomingProps, autoSizeTextAreaDefaultProps);

  const autoSize = (myRef: React.RefObject<HTMLTextAreaElement | null>) => {
    const node = myRef.current;
    if (!node) {
      return;
    }
    node.style.height = "auto";
    node.style.height = node.scrollHeight + 4 + "px";
  };

  const delayedResize = (
    myRef: React.RefObject<HTMLTextAreaElement | null>
  ) => {
    window.setTimeout(() => autoSize(myRef), 0);
  };

  const setTextAreaRef = useRefCallback<HTMLTextAreaElement>(myRef =>
    autoSize(myRef)
  );

  return (
    <TextArea
      {...props}
      reference={setTextAreaRef.referenceFn}
      changeFn={() => autoSize(setTextAreaRef.reference)}
      delayedChangeFn={() => delayedResize(setTextAreaRef.reference)}
      rows={1}
      hasBottomPadding={false}
      additionalStyles={{ padding: "3px", ...props.additionalStyles }}
    />
  );
}

const autoSizeTextAreaDefaultProps = {
  additionalStyles: {}
};
